import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TawkTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // jab bhi route change ho
    if (window.Tawk_API && typeof window.Tawk_API.setAttributes === "function") {
      window.Tawk_API.setAttributes(
        {
          page: location.pathname,   // yaha exact route bhej rahe hain
        },
        function (error) {
          if (error) {
            console.error("Tawk.to attribute error:", error);
          }
        }
      );
    }

    // optional: Tawk ke native page view tracker ko bhi call karna
    if (window.Tawk_API && typeof window.Tawk_API.addTags === "function") {
      window.Tawk_API.addTags([location.pathname]); 
    }
  }, [location]);

  return null;
};

export default TawkTracker;
